import React, { useEffect, useRef, useState } from 'react'
import Header from '../components/Header'
import Rightmenu from '../components/Rightmenu'
import Leftmenu from '../components/Leftmenu'
import { Link, useOutletContext } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import PostCard from "../components/PostCard";
import FriendCardMain from '../components/FriendCardMain';
import EventCard from '../components/EventCard';
function Home() {
    const [selectedImages, setSelectedImages] = useState([]);
      const { user, token } = useOutletContext();
      const [posts, setPosts] = useState([]);
      const [frindrequest, setFrindrequest] = useState([]);
      const [friend, setFriend] = useState([]);
      const [events, setEvents] = useState([]);
      const {logout} = useAuth();
      const [loader, setLoader] = useState(false);
        // Pagination
        const loaderRef = useRef(null);
        const [page, setPage] = useState(1);
        const [loading, setLoading] = useState(false);
        const [hasMore, setHasMore] = useState(true);
      
      
        const handleImageChange = (e) => {
            const selectedImages = e.target.files;
            setSelectedImages([...selectedImages]);
          
        }
        const postCreate= (e) => {
            setLoader(true);
            e.preventDefault();
            const formData = new FormData();
            for (let i = 0; i < selectedImages.length; i++) {
                formData.append('images[]', selectedImages[i]);
            }
            formData.append('message', e.target.message.value);
            fetch('api/post-create', {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            }).then((response) => response.json())
            .then((data) => {
                if (data.extraerror) {
                    
                }
                else if(data.data && data.message) {
                   
                    e.target.reset();
                     e.target.reset();
                    setSelectedImages([]);
                    setPosts([data.data ,...posts]);
                }
                setLoader(false);

              
            }).catch((error) => {
                
            });
        }

      const getPosts = () => {
    if (loading || !hasMore) return; // prevent multiple calls

    setLoading(true);

    fetch('api/get-feed-posts?page=' + page, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
    .then((response) => response.json())
    .then((data) => {
        if (data.data.extraerror) {
            setLoading(false);
            return;
        }

        if (data.data.data && data.data.data.length > 0) {
            // Use functional update to get latest posts
            setPosts((prevPosts) => [...prevPosts, ...data.data.data]);
           
            setHasMore(data.data.data.length > 0);
        } else {
            console.log("No more data");
            setHasMore(false); // no more data
        }

        setLoading(false);
    })
    .catch((error) => {
        console.error(error);
        setLoading(false);
    });
};



        const getFrindrequest = () => {
            fetch('/api/get-home-friend-request', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }).then((response) => response.json())
                .then((data) => {
                   
                    setFrindrequest(data.data);
              
                }).catch((error) => {
                   
                });
        }
        const getEvents = () => {
            fetch('/api/get-event-list-home', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }).then((response) => response.json())
                .then((data) => {
                    
                    setEvents(data.data);
                }).catch((error) => {
                    
                });
        }
     
        useEffect(() => {
            getPosts();
            getFrindrequest();
            getEvents();

        }, [])



        //pegination 
         // Watch for loader in viewport
  useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        setPage(prevPage => {
          if (!loading && hasMore) {
            return prevPage + 1;
          }
          return prevPage;
        });
      }
    },
    { threshold: 0.1 }
  );

  if (loaderRef.current) observer.observe(loaderRef.current);
  return () => {
    if (loaderRef.current) observer.unobserve(loaderRef.current);
  };
}, [loading, hasMore]);


  // Fetch new posts when page changes
  useEffect(() => {
    if (page > 1) {
      getPosts();
    }
  }, [page]);

  
  return (
    <div>    
        {loader && <div  className="preloader"></div>}
        <Header />
        <Leftmenu />
         <Rightmenu />
        <div className="main-content ">
            
            <div className="middle-sidebar-bottom">
                <div className="middle-sidebar-left">
                   
                    <div className="preloader-wrap p-3">
                        <div className="box shimmer">
                            <div className="lines">
                                <div className="line s_shimmer"></div>
                                <div className="line s_shimmer"></div>
                                <div className="line s_shimmer"></div>
                                <div className="line s_shimmer"></div>
                            </div>
                        </div>
                        <div className="box shimmer mb-3">
                            <div className="lines">
                                <div className="line s_shimmer"></div>
                                <div className="line s_shimmer"></div>
                                <div className="line s_shimmer"></div>
                                <div className="line s_shimmer"></div>
                            </div>
                        </div>
                        <div className="box shimmer">
                            <div className="lines">
                                <div className="line s_shimmer"></div>
                                <div className="line s_shimmer"></div>
                                <div className="line s_shimmer"></div>
                                <div className="line s_shimmer"></div>
                            </div>
                        </div>
                    </div>
                   
                    <div className="row feed-body">

                        <div className="col-xl-8 col-xxl-9 col-lg-8">
                            <form onSubmit={postCreate} className="card w-100 shadow-xss rounded-xxl border-0 ps-4 pt-4 pe-4 pb-3 mb-3">

                                <div className="card-body p-0">
                                    <div href="#" className=" font-xssss fw-600 text-grey-500 card-body p-0 d-flex align-items-center"><i className="btn-round-sm font-xs text-primary feather-edit-3 me-2 bg-greylight"></i>Create Post</div>
                                </div>
                                <div className="card-body p-0 mt-3 position-relative">
                                    <figure className="avatar position-absolute ms-2 mt-1 top-5"><img src={user?.personal_info.profile_picture} alt="image" className="shadow-sm rounded-circle w30" /></figure>
                                    <textarea id='message' required name="message" className="h100 bor-0 w-100 rounded-xxl p-2 ps-5 font-xssss text-grey-500 fw-500 border-light-md theme-dark-bg" cols="30" rows="10" placeholder="What's on your mind?"></textarea>
                                </div>
                           

                                    {selectedImages.length > 0 && (
                                        <div className="row ps-2 pe-2">
                                            {selectedImages.slice(0, 2).map((image, index) => (
                                                <div key={index} className="col-xs-4 col-sm-4 p-1">
                                                    <div href={URL.createObjectURL(image)} data-lightbox="roadtrip">
                                                        <img className="rounded-3 w-100" alt="image" src={URL.createObjectURL(image)} />
                                                    </div>
                                                </div>
                                            ))}
                                            {selectedImages.length > 2 && (
                                                <div className="col-xs-4 col-sm-4 p-1">
                                                    <div href={URL.createObjectURL(selectedImages[2])} data-lightbox="roadtrip" className="position-relative d-block">
                                                        <img className="rounded-3 w-100" alt="image" src={URL.createObjectURL(selectedImages[2])} />
                                                        {selectedImages.length > 3 && (
                                                            <span className="img-count font-sm text-white ls-3 fw-600">
                                                                <b>+{selectedImages.length - 3}</b>
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                   
                                <div className="card-body d-flex p-0 mt-0 justify-content-between">
                                    <input type="file" id='file-upload' className='visually-hidden' multiple accept="image/*" onChange={handleImageChange} />

                                    <label htmlFor="file-upload" className="d-flex align-items-center font-xssss fw-600 ls-1 text-grey-700 text-dark pe-4" style={{cursor: 'pointer'}}> <i className="font-md text-success feather-image me-2"></i><span >Attach Photos (max 10 images)</span></label>

                                  <button type="submit" className="p-2 lh-20 w100 bg-primary-gradiant me-2 text-white text-center font-xssss fw-600 ls-1 rounded-xl color-theme-red btn">Post</button>
                                </div>
                            </form>


                            <div className="w-100 all-home-post-section">
                            
                           {posts.map((post) => (
                                <PostCard
                                    key={post.id}
                                    post={post}
                                    onDelete={(deletedId) =>
                                        setPosts((prev) => prev.filter((p) => p.id !== deletedId))
                                    }
                                />
                            ))}
                       
                          
                                    

                           
                           {/* Loader (Triggers IntersectionObserver) */}
                  { (
                    <div
                      ref={loaderRef}
                      className="card w-100 text-center shadow-xss rounded-xxl border-0 p-4 mb-3 mt-3"
                    >
                      {hasMore ? (
                        <div className="snippet mt-2 ms-auto me-auto">
                          <div className="stage">
                            <div className="dot-typing"></div>
                          </div>
                        </div>
                      ) : (
                        <p className="text-muted mb-0">You have reached the end</p>
                      )}
                    </div>
                  )}
                            </div>

                        </div>               
                        <div className="col-xl-4 col-xxl-3 col-lg-4 ps-lg-0">
                            <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
                                <div className="card-body d-flex align-items-center p-4">
                                    <h4 className="fw-700 mb-0 font-xssss text-grey-900">Friend Request</h4>
                                    <Link to="/friend-request" className="fw-600 ms-auto font-xssss text-primary">See all</Link>
                                </div>
                                {frindrequest.length > 0 ? (
                                    frindrequest.map((fq) => (
                                        <FriendCardMain key={fq.id} data={fq} type={"request-mini"} />
                                    )) 
                                ) : (
                                    <div className="card-body d-flex align-items-center p-4">
                                        <h4 className="fw-700 mb-0 font-xssss text-grey-900">No Friend Request</h4>
                                    </div>
                                )
                                }
                               
                            </div>

                            

                 

                    


                            <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
                                <div className="card-body d-flex align-items-center  p-4">
                                    <h4 className="fw-700 mb-0 font-xssss text-grey-900">Event</h4>
                                    <Link to="/events" className="fw-600 ms-auto font-xssss text-primary">See all</Link>
                                </div>
                                {
                                    events.length > 0 ? (
                                        events.map((event) => (
                                            <EventCard key={event.id} data={event} type={"mini"} />
                                        ))
                                    ) : (
                                        <div className="card-body d-flex align-items-center  p-4">
                                            <h4 className="fw-700 mb-0 font-xssss text-grey-900">No Event</h4>
                                        </div>
                                    )
                                }
                                 
                            </div>
                        </div>

                    </div>
                </div>
                
            </div>            
        </div>
       
       

        
    
        
     

       

    </div> 
  )
}

export default Home